export const EXTENSION_FIELDS = [
  "displayName",
  "secretId",
  "assignmentUnit",
  "environment",
  "serviceIdentifier",
  "serviceGroup",
  "tenantId",
  "subscriptionKey",
  "applicationId",
];

export const FIELD_VALIDATORS: Record<string, (v: any, all: any) => string[]> =
  {
    secretId: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      return errors;
    },
    applicationId: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      return errors;
    },
    serviceIdentifier: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      if (v && v.length < 36) errors.push("Min 36 chars");
      return errors;
    },
    tenantId: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      return errors;
    },
    environment: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (v && v !== "Prod") errors.push("Must be 'Prod'");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      return errors;
    },
    subscriptionKey: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      return errors;
    },
    serviceGroup: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      if (v && v.length < 4) errors.push("Min 4 chars");
      return errors;
    },
    displayName: (v) => {
      const errors: string[] = [];
      if (!v) errors.push("Required");
      if (typeof v === "string" && /\s$/.test(v))
        errors.push("No trailing whitespace allowed");
      if (v && v.length < 5) errors.push("Min 5 chars");
      return errors;
    },
  };
